import { useCallback, useEffect, useState } from "react";
import "./App.scss";
import Loader from "./components/common/Loader/Loader";
import Pages from "./components/routing/Router";
import { getActiveLocation, getCurrentRestaurant } from "./services/CommonService";
import { UserService } from "./services/UserService";
import { setLocations } from "./store/Reducer/Menu/MenuReducer";
import { setPrivateOnly } from "./store/Reducer/PrivateOnly/PrivateOnly";
import { setRestaurantLoading, setSelectedRestaurant } from "./store/Reducer/SelectedRestaurant/SelectedRestaurantReducer";
import { userData } from "./store/Reducer/User/UserReducer";
import { useAppDispatch, useAppSelector } from "./store/StoreHooks";

function App() {
  const dispatch = useAppDispatch();
  const [restaurantId, setRestaurantId] = useState<number>(() => {
    // Initialize from localStorage
    return Number(localStorage.getItem('restaurant_id')) || 0;
  });
  const loader = useAppSelector((val) => val.loader);

  const setDefaultRestaurantId = useCallback((restaurantId: number) => {
    if (restaurantId) {
      dispatch(setRestaurantLoading(true));
      (async () => {
        const res = await getCurrentRestaurant(restaurantId);

        if (!res?.data?.data?.is_public) {
          localStorage.clear();
        }

        if (res?.data?.data && res?.data?.data?.type === 'private') {
          dispatch(setPrivateOnly(true));
        }
        const locations = await getActiveLocation();
        if (locations?.data?.data) {
          dispatch(setLocations({ location: locations?.data?.data }));
        }
        if (res?.data?.data && res?.data?.data?.is_public) {
          const data: any = res.data.data;
          data.timings = JSON.parse(data.timings)
          let ctime = ''
          let stime = ''
          if (data && data.timings) {
            const today = new Date();
            ctime = data?.timings[today.getDay()]?.closing_time;
            stime = data?.timings[today.getDay()]?.opening_time
            data.closing_time = ctime ? ctime : ''
            data.opening_time = stime ? stime : ''
          }
          const closingTime = localStorage.getItem('closing_time')
          const openingTime = localStorage.getItem('opening_time')
          if (!closingTime) {
            localStorage.setItem('closing_time', ctime)
          }
          if (!openingTime) {
            localStorage.setItem('opening_time', stime)
          }
          dispatch(setSelectedRestaurant({ restaurant: data, closing_time: ctime, opening_time: stime }));
        }
        dispatch(setRestaurantLoading(false));
      })();

      // Create a function which check if token exist then send a request to get the user details
      const checkToken = async () => {
        const token = localStorage.getItem('token');
        if (token) {
          const res = await UserService.getUserDetails();
          if (res?.data?.data) {
            dispatch(userData(res.data.data));
          }
        }
      }
      checkToken();
    }
  }, [dispatch]);

  // Check for URL parameters on initial load
  useEffect(() => {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const urlRestaurantId = urlParams.get('restaurant_id');
    
    if (currentPath.includes('signup') && token && urlRestaurantId &&(Number(urlRestaurantId) !== restaurantId)) {
      const newRestaurantId = Number(urlRestaurantId);
      setRestaurantId(newRestaurantId);
      localStorage.setItem('restaurant_id', urlRestaurantId);
      setDefaultRestaurantId(newRestaurantId);
    } else {
      setDefaultRestaurantId(restaurantId);
    }
    console.log('New Restaurant ID', restaurantId);
  }, [setDefaultRestaurantId, restaurantId]); // Only run once on mount

  return (
    <>
      <Pages />
      <Loader load={loader} />
    </>
  );
}

export default App;
